/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/reference/config-files/gatsby-browser/
 */

// Import global Tailwind CSS styles
import './src/styles/global.css'
import { getNavigationScrollPosition } from './src/utils/navigation-scroll'

// Scroll to top on every page navigation
export const onRouteUpdate = ({ location }) => {
  requestAnimationFrame(() => {
    window.scrollTo(0, 0)
  })

  // Update html lang attribute on client-side navigation
  const lang = location.pathname.startsWith('/en') ? 'en' : 'de'
  document.documentElement.setAttribute('lang', lang)
}

export const shouldUpdateScroll = ({ routerProps: { location } }) => {
  const scrollPosition = getNavigationScrollPosition(location)

  // Keep the existing explicit reset for regular page navigation.
  if (scrollPosition === false) {
    window.scrollTo(0, 0)
  }

  return scrollPosition
}
